export enum DisplayMoveabilityEnum {
  FIXED = "fixed",
  ARTICULATING = "articulating",
  FLIPABLE = "flipable",
  UNKNOWN = "unknown"
}
